import React, { useRef } from 'react';
import styled from 'styled-components';
import {
  ArrowButtons,
  Container,
  ContainerPadding,
  Gallery as CoreGallery,
  GallerySlide,
  Text,
  TextAlignment,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { Acceleration, PopularCarPrivate, TestDrive } from '@volkswagen-onehub/icons-core';
import ScrollHintArrow from '../ScrollHintArrow';

type Feature = {
  title: string;
  description: string;
  icon: React.ReactNode;
};

const FEATURES: Feature[] = [
  {
    title: 'MOTOR DEPORTIVO',
    description:
      'El Golf GTI tiene 265CV de potencia, acelera de 0 a 100km/h en menos de 6 segundos y alcanza una velocidad máxima de 250km/h. Tiene un motor deportivo, transmisión DSG de 7 velocidades y pura adrenalina en el acelerador.',
    icon: <Acceleration variant="default" aria-hidden />,
  },
  {
    title: 'ACABADO GTI',
    description:
      'Si eliges el acabado GTI, tendrás un modelo deportivo, pero equilibrado. Con detalles de diseño que lo hacen único, es la mejor opción para saborear la adrenalina en momentos especiales y también en el día a día.',
    icon: <PopularCarPrivate variant="default" aria-hidden />,
  },
  {
    title: 'ACABADO CLUBSPORT',
    description:
      'Si te quedas con el acabado Clubsport, descubrirás qué es la deportividad y efectividad pura, tanto por sus 300CV de potencia como por su tren de rodaje con mayores frenos y suspensión adaptativa de serie.',
    icon: <TestDrive variant="default" aria-hidden />,
  },
];

const ROTATION_IMAGES = [
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_000_6%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 000 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_030_12%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 030 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_060_5%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 060 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_090_9%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 090 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_120_7%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 120 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_150_2%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 150 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_180_11%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 180 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_210_4%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 210 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_240_1%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 240 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_270_3%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 270 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_300_10%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 300 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_330_8%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 330 grados',
  },
];

const RootSection = styled.section`
  position: relative;
`;

const SectionContainer = styled(Container)`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(90deg, rgba(0, 0, 0, 0.78) 0%, rgba(0, 0, 0, 0.28) 36%, rgba(0, 0, 0, 0.82) 100%),
    url('https://assets.volkswagen.com/is/image/volkswagenag/detail-gti-background?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #ffffff;
`;

const ScrollHintArrowLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  width: min(100%, 420px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 560px) {
    width: min(100%, 720px);
  }

  @media screen and (min-width: 960px) {
    width: min(1240px, calc(100vw - 96px));
    grid-template-columns: minmax(320px, 702px) minmax(280px, 1fr);
    gap: clamp(32px, 5vw, 96px);
  }
`;

const GalleryColumn = styled.div`
  position: relative;
  min-width: 0;
  width: 100%;
`;

const OutlineTitle = styled.span`
  position: absolute;
  top: -5%;
  left: 5%;
  z-index: 2;
  width: 100%;

  @media screen and (max-width: 559px) {
    max-width: 200px;
  }

  @media screen and (min-width: 560px) and (max-width: 959px) {
    max-width: 300px;
    left: 3%;
  }

  @media screen and (min-width: 960px) {
    max-width: 300px;
    left: 0%;
  }

  @media screen and (min-width: 1280px) {
    max-width: 400px;
    left: -5%;
  }
`;

const OutlineGti = () => {
  return (
    <svg width="100%" height="auto" viewBox="0 0 569 366" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M137.793 14.25C163.153 14.25 185.07 20.9792 203.508 34.4619C221.939 47.9396 236.845 68.13 248.253 94.9766L248.56 95.6992L247.824 95.9727L164.309 127.072L163.417 127.404L163.302 126.46C162.072 116.318 159.21 108.406 154.771 102.663L154.759 102.647C150.473 96.7933 145.106 93.919 138.62 93.9189C132.889 93.9189 127.885 95.9141 123.575 99.9297C119.249 103.961 115.599 110.053 112.659 118.27C106.778 134.711 103.814 159.454 103.813 192.561C103.813 220.701 106.435 241.03 111.613 253.635C114.197 259.923 117.521 264.58 121.556 267.665C125.582 270.743 130.362 272.291 135.933 272.291C140.351 272.291 144.351 271.205 147.949 269.037C151.557 266.864 154.574 263.802 156.998 259.832L157.003 259.824L157.008 259.817C159.572 255.84 161.542 251.018 162.904 245.339L162.907 245.327C164.352 239.72 165.101 233.519 165.152 226.722H133.322V156.929H255.134V171.128C255.134 233.642 245.971 278.798 227.514 306.447C207.378 336.655 177.571 351.75 138.206 351.75C99.5323 351.75 69.1224 336.939 47.0605 307.32L47.0576 307.315C25.1572 277.445 14.25 236.505 14.25 184.576C14.25 131.948 25.2257 90.3777 47.2617 59.9482C69.3183 29.4906 99.5209 14.25 137.793 14.25ZM452.455 20.1338V99.3818H403.048V346.076H315.345V99.3818H267.799V20.1338H452.455ZM556.75 20.1338V346.076H469.047V20.1338H556.75Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

const GalleryCard = styled.div`
  position: relative;
  z-index: 1;
  width: min(100%, 120vw, 296px);
  margin: 0 auto;

  @media screen and (min-width: 560px) {
    width: min(100%, 78vw, 720px, calc((100vh - 160px) * 0.823));
  }

  @media screen and (min-width: 960px) {
    width: min(1040px, calc(100% - 16px), calc((100vh - 56px) * 0.823));
  }
`;

const GalleryInnerCard = styled.div`
  background: #c90010;
  border-radius: 12px;
  padding: 18px 10px 16px;
  aspect-ratio: 800 / 972;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;

  @media screen and (min-width: 560px) {
    padding: 18px 14px 16px;
  }

  @media screen and (min-width: 960px) {
    padding: clamp(12px, 1.3vw, 20px);
  }
`;

const ImageViewport = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledGallery = styled(CoreGallery)`
  [class*='sc-196wn05'] {
    box-sizing: border-box;
    padding-inline: clamp(10px, 2.4vw, 22px);
  }

  [class*='StyledContainedImageWrapper'] {
    width: 100% !important;
  }
`;

const SlideContent = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: clamp(320px, 78vw, 480px);
  padding: 8px 0;

  @media screen and (min-width: 960px) {
    height: 100%;
    min-height: 0;
    padding: 0;
  }
`;

const CarImage = styled.img`
  width: min(120%, 720px);
  height: auto;
  object-fit: contain;
  user-select: none;
  pointer-events: none;

  @media screen and (min-width: 560px) {
    width: min(100%, 900px);
  }

  @media screen and (min-width: 960px) {
    height: clamp(558px, 39.6vw, 774px);
    width: auto;
    max-width: min(117%, 1224px);
  }
`;

const ArrowButtonsWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  justify-content: center;
  width: calc(100% + 90px);
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 0 8px;

  @media screen and (min-width: 560px) {
    padding: 0 16px;
    width: calc(100% + 120px);
  }

  @media screen and (min-width: 960px) {
    padding: 0 56px;
  }

  button {
    background-color: #c90010 !important;
    border-color: #c90010 !important;
  }

  button:hover {
    background-color: #ffffff !important;
    border-color: #ffffff !important;
  }

  button * {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  button:hover * {
    color: #c90010 !important;
    fill: #c90010 !important;
  }

  button:disabled,
  button[disabled] {
    background-color: #8a010c !important;
    border-color: #8a010c !important;
    opacity: 0.8 !important;
  }
`;

/* Galeria personalizada aparcada temporalmente.
const ArrowIconStyles = `
  color: currentColor;
  fill: currentColor;
`;

const ArrowIcon = styled(ChevronLeft)`
  ${ArrowIconStyles}
`;
*/

const FeatureColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  @media screen and (min-width: 960px) {
    gap: clamp(28px, 3vw, 40px);
  }
`;

const FeatureItem = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  margin: 0 auto;

  @media screen and (min-width: 960px) {
    gap: 12px;
    max-width: 480px;
  }
`;

const IconWrap = styled.div`
  color: #c90010;
  display: none;

  & svg {
    width: clamp(42px, 5vw, 58px);
    height: clamp(42px, 5vw, 58px);
  }

  @media screen and (min-width: 960px) {
    display: block;
  }
`;

const FeatureTitle = styled(Text)`
  color: #ffffff;
  text-transform: uppercase;
  font-family: vw-head;
  font-weight: 800;
`;

const FeatureDescription = styled(Text)`
  color: #ffffff;

  @media screen and (max-width: 559px) {
    padding: 0 36px;
  }

  @media screen and (min-width: 560px) and (max-width: 959px) {
    padding: 0 80px;
  }

  @media screen and (min-width: 960px) {
    max-width: 44ch;
  }
`;

export const Gallery = (): React.ReactElement => {
  return (
    <ImageViewport aria-label="Galeria 360 del Volkswagen Golf GTI 50" role="region">
      <GalleryCard>
        <StyledGallery
          id="detail-gti50-gallery1"
          aria-label="Galeria 360 del Volkswagen Golf GTI 50"
          fadingEdges="none"
          endlessScrolling
          gutter="grid002"
          bottomElements={
            <ArrowButtonsWrapper id="detail-gti50-gallery1-arrow-buttons">
              <ArrowButtons buttonPreviousAriaLabel="Vista anterior" buttonNextAriaLabel="Vista siguiente" />
            </ArrowButtonsWrapper>
          }
        >
          {ROTATION_IMAGES.map((image, index) => (
            <GallerySlide key={image.src} aria-labelledby={`detail-gti50-gallery1-slide-${index}`}>
              <GalleryInnerCard>
                <SlideContent>
                  <CarImage id={`detail-gti50-gallery1-slide-${index}`} src={image.src} alt={image.alt} />
                </SlideContent>
              </GalleryInnerCard>
            </GallerySlide>
          ))}
        </StyledGallery>
      </GalleryCard>
    </ImageViewport>
  );
};

export const DetailGti50 = (): React.ReactElement => {
  const sectionRef = useRef<HTMLElement | null>(null);

  return (
    <RootSection id="detail-gti50-module" ref={sectionRef}>
      <SectionContainer
        padding={{
          top: ContainerPadding.dynamic0300,
          bottom: ContainerPadding.dynamic0300,
        }}
      >
        <Content>
          <GalleryColumn>
            <OutlineTitle>
              <OutlineGti />
            </OutlineTitle>

            <Gallery />
          </GalleryColumn>

          <FeatureColumn>
            {FEATURES.map((feature) => (
              <FeatureItem key={feature.title}>
                <IconWrap>{feature.icon}</IconWrap>
                <FeatureTitle appearance={TokenTextAppearance.headline300}>{feature.title}</FeatureTitle>
                <FeatureDescription appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
                  {feature.description}
                </FeatureDescription>
              </FeatureItem>
            ))}
          </FeatureColumn>
        </Content>

        <ScrollHintArrowLayer>
          <ScrollHintArrow trigger={sectionRef} targetSelector="#gallery-gti50" color="#ffffff" />
        </ScrollHintArrowLayer>
      </SectionContainer>
    </RootSection>
  );
};
